import { CircularProgress } from "@mui/material";

import Card from "./card";
import { UTILITY_STEPS } from "./utilities-config";

export default function PowerLoading() {
  return (
    <Card steps={UTILITY_STEPS} activeStep={0} progress={40}>
      <div className="su-loading">
        <CircularProgress size={36} sx={{ color: "#54FF99" }} />
        <p>Comparing prices...</p>
      </div>
    </Card>
  );
}
